import React from "react";
import { TailSpin } from "react-loader-spinner";

const Spinner = () => {
  return (
    <div className="my-4">
      <TailSpin
        color="var(--app-color-dark)"
        height={50}
        width={50}
        wrapperStyle={{ display: "block" }}
      />
    </div>
  );
};

export default Spinner;
